module.exports = __webpack_public_path__ + "static/media/empty_planner.c3e636cc.png";